// extracted by mini-css-extract-plugin
module.exports = {"container":"StrmrmFoodsSearch_container__1wNN_","row":"StrmrmFoodsSearch_row__1TjEI","loading":"StrmrmFoodsSearch_loading__xlAA7"};